module.exports = __webpack_public_path__ + "static/media/Grupo30mg.b9a7c5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/Grupo30mg.png
// module id = 96
// module chunks = 0